import React from 'react'
import styled from 'styled-components'
import { DarkTheme } from '../components/Themes'

const Logo = styled.h1`
  display: inline-block;
  color: ${props => props.color === 'dark' ? DarkTheme.text : DarkTheme.body};
  font-family: 'Pacifico',cursive;
  position: fixed;
  left: 2rem;
  top: 2rem;
  z-index:3;

  /* Fix for blurry text during scroll */
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  /* Prevent text selection */
  user-select: none;

  @media (max-width: 768px) {
    font-size: 1.8em;
    left: 1rem;
    top: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 1.8em;
    left: 0.5rem;
    top: 1.5rem;
  }
`

const LogoComponent = (props) => {
    return (
        <Logo color={props.theme}>
          Pratik
        </Logo>
    )
}

export default LogoComponent